// Convert a number to string, with a number of prefix characters to match required length. Ex:
// pad(19, 3);      -> 019
// pad(9, 4);       -> 0009
// pad(123, 4);     -> 0123
// pad(10, 4, '-'); -> --10
export function padNumber(number, size, prefix = '0') {
  return prefix.repeat(size - number.toString().length) + number.toString();
}
